import { render } from "./topLabelPart.vue?vue&type=template&id=51db8316&scoped=true"
import script from "./topLabelPart.vue?vue&type=script&lang=js"
export * from "./topLabelPart.vue?vue&type=script&lang=js"

import "./topLabelPart.vue?vue&type=style&index=0&id=51db8316&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51db8316"]])

export default __exports__